

export const goodsManageListNewData = [
  {
    id: 'baseInfo',
    title: '博物馆录入',
    footerShow:'special',
    data: [
      {
        id: 'id',
        name: '博物馆名称',
        placeholder: '请输入博物馆名称',
        type: 'select',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'id'
      },
      // {
      //   id: 'password',
      //   name: '博物馆所处省份',
      //   placeholder: '请输入密码',
      //   type: 'input',
      //   checkType: '',
      //   tips:'',
      //   newDisabled: false,
      //   editDisabled: false,
      //   newShow: true,
      //   editShow: true,
      //   value: '',
      //   options: [],
      //   expand: {},
      //   jpath: ''
      // },
      {
        id: 'jointype',
        name: '参评方式',
        placeholder: '',
        type: 'radio',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: [],
        tips:'',
        options: [
          {name:'本省推荐',value:'1D10'},
          {name:'自主申请',value:'1D12'},
        ],
        expand: {},
        jpath: 'jointype'
      },
      {
        id: 'adminname',
        name: '联系人',
        placeholder: '请输入联系人',
        type: 'input',
        checkType: '',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'adminname'
      },
      {
        id: 'adminphone',
        name: '联系电话',
        placeholder: '请输入联系电话',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'adminphone'
      },
    ]
  }
];
